import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Plugins, Sortable } from '@shopify/draggable';
import { Row } from 'react-bootstrap';

const isPrevented = element => {
  let currentElem = element;
  let prevented = false;

  while (currentElem) {
    const hasClass = currentElem.classList.contains('prevent-drag');

    if (hasClass) {
      prevented = true;
      currentElem = undefined;
    } else {
      currentElem = currentElem.parentElement;
    }
  }

  return prevented;
};

const getRandomClassName = () => {
  const random = Math.floor(Math.random() * 1000000);
  return `draggable-${random}`;
};

const DragWrapperRow = ({ children, setItems, options, className }) => {
  const { draggingItemClassName } = options;

  const [draggableClassName] = useState(getRandomClassName());

  const [sortable, setSortable] = useState(null);

  useEffect(() => {
    if (sortable) {
      sortable?.destroy();
      setSortable(null);
    }
  }, [draggingItemClassName]);

  useEffect(() => {
    if (sortable) {
      sortable.on('sortable:start', onDragStart);
      sortable.on('drag:stopped', onDragStop);
    }
  }, [sortable]);

  const initDraggable = containerEl => {
    if (sortable || !containerEl) {
      return;
    }

    setSortable(
      new Sortable(containerEl, {
        draggable: '.' + draggableClassName,
        mirror: {
          appendTo: containerEl,
          constrainDimensions: true
        },
        plugins: [Plugins.ResizeMirror]
      })
    );
  };

  const onDragStart = event => {
    const { originalSource, source, originalEvent } = event.data.dragEvent;
    const currentTarget = originalEvent.target;

    // If the current target is not a draggable item, then we don't want to
    // continue.
    if (isPrevented(currentTarget)) {
      event.cancel();
    } else {
      // Add drag class to the source element.
      originalSource.classList.add(`d-none`);

      const classNamesArr = draggingItemClassName.split(' ');
      classNamesArr.forEach(className => source.classList.add(className));
    }
  };

  const onDragStop = ({ data }) => {
    const { originalSource, source, sourceContainer } = data;
    // Remove drag class from source element.
    originalSource.classList.remove(`d-none`);

    const classNamesArr = draggingItemClassName.split(' ');
    classNamesArr.forEach(className => source.classList.remove(className));

    const newArrHtml = Array.from(sourceContainer.children).filter(
      item => item.dataset.index !== 'fixed'
    );
    const newOrder = newArrHtml.map(item => item.dataset.index);

    setItems(prev => newOrder.map(index => prev[index]));

    newArrHtml.forEach((item, index) => {
      item.dataset.index = index;
    });
  };

  return (
    <Row className={className} ref={initDraggable}>
      {children({ draggableClassName })}
    </Row>
  );
};

DragWrapperRow.defaultProps = {
  options: {
    draggingItemClassName: 'border border-red'
  }
};

DragWrapperRow.propTypes = {
  children: PropTypes.func,
  setItems: PropTypes.func,
  className: PropTypes.string,
  options: PropTypes.shape({
    draggingItemClassName: PropTypes.string
  })
};

export default DragWrapperRow;
